import React from "react";
import AuthLayout from "../components/layouts/AuthLayout";
import LoginForm from "../auth/LoginForm";
import { useAuth } from "../auth/AuthContext";
import { Navigate } from "react-router-dom";

const LoginPage = () => {
  const { isAuthenticated } = useAuth();

  // Si el usuario ya está autenticado, redirigir al dashboard
  if (isAuthenticated) {
    return <Navigate to="/" />; // Redirigir a la raíz (dashboard)
  }

  return (
    <AuthLayout 
      title="Benvingut de nou" 
      subtitle="Inicia sessió per a continuar."
    >
      <LoginForm />
      <div className="mt-4 text-center">
        <p className="mb-0 text-muted">
          No tens compte?{" "}
          <a href="/register" className="fw-semibold text-primary text-decoration-underline">
            Registra't ara
          </a>
        </p>
      </div>
    </AuthLayout>
  );
};

export default LoginPage;
